import script from "./AudioMessage.vue?vue&type=script&setup=true&lang=js"
export * from "./AudioMessage.vue?vue&type=script&setup=true&lang=js"

import "./AudioMessage.vue?vue&type=style&index=0&id=b5606814&lang=scss"

const __exports__ = script;

export default __exports__